// import React, { useCallback, useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { toast } from 'react-toastify';
// import { formatMessage } from '../../translations/format-message';

// const SUPPORTED_FORMATS_IMAGES_AND_PDF = ['.jpg', '.jpeg', '.png', '.pdf'];
// const MAX_SIZE_MB = 10;
// const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

// interface Props {
//   setFieldValue: (field: string, value: any) => void;
//   errors: any;
//   headingInputRef: React.RefObject<HTMLInputElement>;
//   props: any;
//   setIsEnable: (value: boolean) => void;
//   fileInputRef: React.RefObject<HTMLInputElement>;
//   setFile: (file: File) => void;
//   setPreview: any;
//   preview : any;
// }

// const DragDropFileInput: React.FC<Props> = ({
//   setFieldValue,
//   // errors,
//   headingInputRef,
//   props,
//   setIsEnable,
//   fileInputRef,
//   setFile,
//   setPreview,
//   preview
// }) => {
//   const [uploadedFile, setUploadedFile] = useState<File | null>(null);
//   // const fileInputRef = useRef<HTMLInputElement>(null);

//   const onDrop = useCallback(
//     (acceptedFiles: File[]) => {
//       const file = acceptedFiles[0];
//       if (!file) return;

//       const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();

//       if (!SUPPORTED_FORMATS_IMAGES_AND_PDF.includes(fileExtension)) {
//         toast.error(
//           `Unsupported file type. Only ${SUPPORTED_FORMATS_IMAGES_AND_PDF.join(', ')}`
//         );
//         return;
//       }

//       if (file.size > MAX_SIZE_BYTES) {
//         toast.error(`File size should not exceed ${MAX_SIZE_MB} MB.`);
//         return;
//       }

//       setUploadedFile(file);
//       setFieldValue('file', file);
//       setFieldValue(props.data.ProductFiles[0], file);
//       setFile(file);

//       const headingValue = headingInputRef?.current?.value || '';
//       setIsEnable(file.name.length > 0 && headingValue.length > 0);

//       const reader = new FileReader();
//       reader.onloadend = () => setPreview(reader.result);
//       reader.readAsDataURL(file);
//     },
//     [setFieldValue, props, headingInputRef, setIsEnable]
//   );

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     multiple: false,
//     accept: {
//       'image/*': SUPPORTED_FORMATS_IMAGES_AND_PDF,
//       'application/pdf': SUPPORTED_FORMATS_IMAGES_AND_PDF,
//     },
//   });

//   return (
//     <div className="form-group drag-images mb-0">
//       <div
//         {...getRootProps()}
//         className={`border p-1 py-2 text-center  drag-box w-100 ${
//           isDragActive ? 'bg-primary' : 'border-secondary'
//         }`}
//         style={{ cursor: 'pointer' }}
//       >
//         <input
//           {...getInputProps()}
//           name="file"
//           //  ref={fileInputRef}
//         />{' '}
//         {/* ✅ No ref here */}
//         {isDragActive ? (
//           <p>{formatMessage('drop_file_here')}</p>
//         ) : (
//           <small>
//             {!preview && formatMessage('drag_drop')} <a>{ !preview && formatMessage('click_browse')}</a>
//           </small>
//         )}
//       </div>

//       {uploadedFile && (
//         <p className="mt-2 text-center file-name-uploaded show-Elipses">
//           {formatMessage('selected_file')}
//           {uploadedFile.name}
//         </p>
//       )}

//       {/* {(errors.productImages || errors.heading) && (
//         <div className="text-danger errorMessage mt-1">
//           {String(errors.productImages || errors.heading)}
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default DragDropFileInput;

import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useDropzone, FileRejection } from 'react-dropzone';
import toast from 'react-hot-toast';
import { formatMessage } from '../../translations/format-message';

const SUPPORTED_FORMATS_IMAGES_AND_PDF = ['.jpg', '.jpeg', '.png', '.pdf'];
const MAX_SIZE_MB = 10;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

interface Props {
  setFieldValue: (field: string, value: any) => void;
  errors: any;
  headingInputRef: React.RefObject<HTMLInputElement>;
  props: any;
  setIsEnable: (value: boolean) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  setFile: (file: File) => void;
  setPreview: any;
  preview: any;
  restrictedType?: 'image' | 'pdf' | null;
}

const DragDropFileInput: React.FC<Props> = ({
  setFieldValue,
  headingInputRef,
  props,
  setIsEnable,
  fileInputRef,
  setFile,
  setPreview,
  preview,
  restrictedType
}) => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const localInputRef = useRef<HTMLInputElement>(null);

  const processFile = useCallback(
    (file: File) => {
      const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
      if (!SUPPORTED_FORMATS_IMAGES_AND_PDF.includes(fileExtension)) {
        toast.error(formatMessage('supported_only_image_or_pdf_format'));
        return;
      }

      if (restrictedType) {
        const isPdf = file.type === 'application/pdf';
        if (restrictedType === 'pdf' && !isPdf) {
          toast.error(formatMessage('invalid_pdf_file_format'));
          return;
        }
        if (restrictedType === 'image' && isPdf) {
          toast.error(formatMessage('supported_only_image_format'));
          return;
        }
      }

      if (file.size > MAX_SIZE_BYTES) {
        toast.error(`File size should not exceed ${MAX_SIZE_MB} MB.`);
        return;
      }

      setUploadedFile(file);
      setFieldValue('file', file);
      // setFieldValue(props.data.ProductFiles[0], file);
      setFile(file);

      const headingValue = headingInputRef?.current?.value || '';
      setIsEnable(file.name.length > 0 && headingValue.length > 0);

      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    },
    [setFieldValue, props, headingInputRef, setIsEnable, restrictedType, setFile, setPreview]
  );

  // useDropzone handles drag/drop, but we manually control file input click
  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections && fileRejections.length > 0) {
        fileRejections.forEach((rejection) => {
          rejection.errors.forEach((err) => {
            if (err.code === 'file-invalid-type') {
              if (restrictedType === 'pdf') {
                toast.error(formatMessage('invalid_pdf_file_format'));
              } else if (restrictedType === 'image') {
                toast.error(formatMessage('supported_only_image_format'));
              } else {
                toast.error(formatMessage('invalid_file_format'));
              }
            } else if (err.code === 'file-too-large') {
              toast.error(`File size should not exceed ${MAX_SIZE_MB} MB.`);
            } else {
              toast.error(err.message);
            }
          });
        });
        return;
      }

      const file = acceptedFiles[0];
      if (file) {
        processFile(file);
      }
    },
    [processFile, restrictedType]
  );

  const handlePaste = useCallback(
    (e: React.ClipboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      const items = e.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();
          if (file) {
            const pasteFile = file.name
              ? file
              : new File([file], 'pasted-image.png', { type: file.type });
            processFile(pasteFile);
            break;
          }
        }
      }
    },
    [processFile]
  );

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    // Allow paste commands (Ctrl+V, Cmd+V)
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
      return;
    }
    // Prevent any other character input to keep the UI clean
    if (e.key.length === 1) {
      e.preventDefault();
    }
  }, []);

  const getAcceptedFiles = () => {
    if (restrictedType === 'pdf') return { 'application/pdf': ['.pdf'] };
    if (restrictedType === 'image')
      return { 'image/*': ['.jpg', '.jpeg', '.png'] };
    return {
      'image/*': SUPPORTED_FORMATS_IMAGES_AND_PDF.filter((e) => e !== '.pdf'),
      'application/pdf': ['.pdf'],
    };
  };

  const { getRootProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    noClick: true, // we’ll handle clicks ourselves
    accept: getAcceptedFiles(),
  });

  const handleBrowseClick = () => {
    (fileInputRef?.current || localInputRef.current)?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      processFile(files[0]);
    }
  };

  return (
    <div className="drag-images mb-0">
      <div
        {...getRootProps()}
        onPaste={handlePaste}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        contentEditable={true}
        suppressContentEditableWarning={true}
        className={`text-center drag-box w-100 ${isDragActive ? 'hovered' : ''
          } ${preview ? 'previewed' : ''}`}
        style={{ outline: 'none', caretColor: 'transparent', cursor: 'default' }}
      >
        <svg
          id="fi_9497861"
          fill="currentColor"
          height="55"
          viewBox="0 0 512 512"
          width="55"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          style={{ pointerEvents: 'none' }}
        >
          <path d="m228.49 93.536c0-4.418 3.582-8 8-8h10.306c4.418 0 8 3.582 8 8s-3.582 8-8 8h-10.306c-4.418 0-8-3.582-8-8zm-10.093 36.476c-4.418 0-8 3.582-8 8s3.582 8 8 8h.453c4.418 0 8-3.582 8-8s-3.582-8-8-8zm52.126-28.476h23.515c4.418 0 8-3.582 8-8s-3.582-8-8-8h-23.515c-4.418 0-8 3.582-8 8s3.582 8 8 8zm-40.985 118.385h-118.561c-4.418 0-8 3.582-8 8s3.582 8 8 8h118.562c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-86.329-118.385h69.553c4.418 0 8-3.582 8-8s-3.582-8-8-8h-69.553c-4.418 0-8 3.582-8 8s3.582 8 8 8zm-7.219 163.34c-4.418 0-8 3.582-8 8s3.582 8 8 8h10.306c4.418 0 8-3.582 8-8s-3.582-8-8-8zm158.048-89.91h-23.553c-4.418 0-8 3.582-8 8s3.582 8 8 8h23.553c4.418 0 8-3.582 8-8s-3.582-8-8-8zm0-44.954h-51.46c-4.418 0-8 3.582-8 8s3.582 8 8 8h51.46c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-232.579 16h133.21c4.418 0 8-3.582 8-8s-3.582-8-8-8h-133.21c-4.418 0-8 3.582-8 8s3.582 8 8 8zm111.642 208.774h-62.124c-4.418 0-8 3.582-8 8s3.582 8 8 8h62.124c4.418 0 8-3.582 8-8s-3.582-8-8-8zm8.062-44.955h-30.678c-4.418 0-8 3.582-8 8s3.582 8 8 8h30.678c4.418 0 8-3.582 8-8s-3.582-8-8-8zm18.75-44.955h-29.89c-4.418 0-8 3.582-8 8s3.582 8 8 8h29.89c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-112.665 89.91h-25.789c-4.418 0-8 3.582-8 8s3.582 8 8 8h25.789c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-25.789-163.82h185.298c4.418 0 8-3.582 8-8s-3.582-8-8-8h-185.298c-4.418 0-8 3.582-8 8s3.582 8 8 8zm0 134.865h65.298c4.418 0 8-3.582 8-8s-3.582-8-8-8h-65.298c-4.418 0-8 3.582-8 8s3.582 8 8 8zm0-89.91h25.789c4.418 0 8-3.582 8-8s-3.582-8-8-8h-25.789c-4.418 0-8 3.582-8 8s3.582 8 8 8zm0 44.955h50.802c4.418 0 8-3.582 8-8s-3.582-8-8-8h-50.802c-4.418 0-8 3.582-8 8s3.582 8 8 8zm447.541 82.204c0 80.46-65.46 145.92-145.92 145.92h-280.58c-13.14 0-23.82-10.68-23.82-23.82v-31.86h-31.86c-13.14 0-23.82-10.68-23.82-23.81v-320.49c0-8.86 3.31-16.86 9.58-23.13l73.31-73.31c6.27-6.27 14.27-9.58 23.13-9.58h219.66c13.13 0 23.82 10.68 23.82 23.82v31.86h31.86c13.13 0 23.82 10.68 23.82 23.82v141.81c58.45 19.04 100.82 74.05 100.82 138.77zm-73.95 20.1c0-4.41-3.58-8-8-8s-8 3.59-8 8v21.68c0 6.61-5.38 12-12 12h-87.93c-6.62 0-12-5.39-12-12v-21.68c0-4.41-3.58-8-8-8s-8 3.59-8 8v21.68c0 15.44 12.56 28 28 28h87.93c15.44 0 28-12.56 28-28zm-79.97-62.55v67.45c0 4.42 3.59 8 8 8s8-3.58 8-8v-67.45l8.48 8.48c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34c3.12-3.13 3.12-8.19 0-11.32l-22.14-22.13c-3.12-3.13-8.19-3.13-11.31 0l-22.14 22.13c-3.12 3.13-3.12 8.19 0 11.32 3.13 3.12 8.19 3.12 11.32 0zm-2.58-103.07c3.49-.26 7.02-.39 10.58-.39 9.96 0 19.69 1.01 29.1 2.92v-137.59c0-4.31-3.51-7.82-7.82-7.82h-31.86zm-114.98 219.76c-12.92-21.76-20.35-47.15-20.35-74.24 0-71.37 51.52-130.94 119.33-143.47v-192.79c0-4.31-3.51-7.82-7.82-7.82h-211.63c-5.58 2.87-9.12 8.55-9.12 14.87v50.25c0 13.13-10.68 23.81-23.81 23.81h-50.25c-6.32 0-12 3.54-14.87 9.12v312.46c0 4.31 3.51 7.81 7.82 7.81zm59.17 55.68c-18.78-9.64-35.22-23.24-48.19-39.68h-173.82v31.86c0 4.31 3.51 7.82 7.82 7.82z"></path>
        </svg>
        <input
          type="file"
          ref={fileInputRef || localInputRef}
          style={{ display: 'none' }}
          accept={Object.values(getAcceptedFiles()).flat().join(',')}
          onChange={handleFileChange}
        />
        {isDragActive ? (
          <small>{formatMessage('drop_file_here')}</small>
        ) : (
          <small>
            <span className="text-dark">{formatMessage('drag_drop')} </span>
            <a
              href="#"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleBrowseClick();
              }}
            >
              {formatMessage('click_browse')}
            </a>
          </small>
        )}
      </div>

      {preview && uploadedFile && (
        <p className="uploaded-file-name text-center show-Elipses ">
          {formatMessage('selected_file')} {uploadedFile.name}
        </p>
      )}
    </div>
  );
};

export default DragDropFileInput;
